export const CONSULT_PATIENT_CANCELLED = 'CONSULT_PATIENT_CANCELLED';
export const CONSULT_PATIENT_REQUEST = 'CONSULT_PATIENT_REQUEST';

export const CONSULT_DOCTOR_ACCEPTED = 'CONSULT_DOCTOR_ACCEPTED';
export const CONSULT_DOCTOR_FINISH = 'CONSULT_DOCTOR_FINISH';
export const CONSULT_EXPIRED = 'CONSULT_EXPIRED';

export const CHANNEL_UPDATE = 'CHANNEL_UPDATE';

export const MESSAGE_UPLOADING_FILE = 'MESSAGE_UPLOADING_FILE';

export const BUBBLE_CHAT_ADD = 'BUBBLE_CHAT_ADD';
export const BUBBLE_CHAT_CLEAR = 'BUBBLE_CHAT_CLEAR';
export const BUBBLE_CHAT_REMOVE = 'BUBBLE_CHAT_REMOVE';
export const BUBBLE_CHAT_LOAD = 'BUBBLE_CHAT_LOAD';
export const BUBBLE_CHAT_TO_MINIMUM = 'BUBBLE_CHAT_TO_MINIMUM';
export const MINIMUM_CHAT_TO_BUBBLE = 'MINIMUM_CHAT_TO_BUBBLE';
export const MINIMUM_CHAT_FOCUSED = 'MINIMUM_CHAT_FOCUSED';
export const MINIMUM_CHAT_FOCUS_OUT = 'MINIMUM_CHAT_FOCUS_OUT';
export const MINIMUM_UPLOAD_GROUP = 'MINIMUM_UPLOAD_GROUP';

export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';

export const SET_ACTIVE_CLINIC_TAB = 'SET_ACTIVE_CLINIC_TAB';
